var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdobeReader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "64px",
    viewBox: "0 0 65 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Adobe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC69\\u200D\\uD83C\\uDF93-Students-management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Platform-Admin-/--Manage-Students-/-Student-Profile-/-Activity-/-Email-Logs-/-F",
    transform: "translate(-505, -695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(394, 123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy",
    transform: "translate(108.5, 572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Adobe",
    transform: "translate(3, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background",
    fill: "#772A34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83C\\uDFA8-Color",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(13.6667, 13.6667)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/App/Adobe-Acrobat",
    transform: "translate(-0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49305556,0 L30.1736111,0 C33.7638889,0 36.6666667,2.97720798 36.6666667,6.65954416 L36.6666667,30.0071225 C36.6666667,33.6894587 33.7638889,36.6666667 30.1736111,36.6666667 L6.49305556,36.6666667 C2.90277778,36.6666667 0,33.6894587 0,30.0071225 L0,6.65954416 C0,2.97720798 2.90277778,0 6.49305556,0 Z",
    id: "Path",
    fill: "#B30B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4861111,21.1597222 C27.7902778,19.3569444 23.1,20.0902778 22,20.2736111 C20.3805556,18.7 19.25,16.8361111 18.8680556,16.1486111 C19.4791667,14.4069444 19.8763889,12.5583333 19.9375,10.7402778 C19.9375,9.09027778 19.2805556,7.31805556 17.4472222,7.31805556 C16.8055556,7.33333333 16.225,7.68472222 15.9041667,8.21944444 C15.125,9.56388889 15.4305556,12.3444444 16.6833333,15.1555556 C15.95,17.2180556 14.8958333,20.1972222 13.5055556,22.6111111 C11.6263889,23.3597222 7.63888889,25.1930556 7.25694444,27.225 C7.13472222,27.8208333 7.34861111,28.4319444 7.80694444,28.8444444 C8.25,29.2416667 8.83055556,29.4402778 9.42638889,29.425 C11.825,29.425 14.2236111,26.0944444 15.8430556,23.2375 C17.2027778,22.7638889 19.3722222,22.1375 21.5569444,21.7402778 C24.0930556,23.9555556 26.3541667,24.2916667 27.5,24.2916667 C29.0583333,24.2916667 29.6388889,23.6194444 29.8527778,23.0541667 C30.0819444,22.4125 29.9444444,21.6791667 29.4861111,21.1597222 Z M27.8361111,22.3208333 C27.7597222,22.7638889 27.1944444,23.2069444 26.1402778,22.9777778 C24.9180556,22.6722222 23.7722222,22.0916667 22.8097222,21.2972222 C23.6347222,21.1597222 25.5597222,20.9763889 26.9194444,21.2361111 C27.4083333,21.3277778 27.9736111,21.6027778 27.8361111,22.3208333 Z M16.8972222,8.8 C17.0041667,8.60138889 17.2027778,8.46388889 17.4319444,8.46388889 C18.0125,8.46388889 18.1347222,9.16666667 18.1347222,9.74722222 C18.0583333,11.1375 17.7527778,12.5583333 17.3708333,13.8263889 C16.3930556,11.2291667 16.5305556,9.42638889 16.8972222,8.8 Z M16.7597222,21.4958333 C17.2791667,20.4722222 18.0125,18.6083333 18.2722222,17.8597222 C18.8527778,18.8222222 19.8305556,20.0291667 20.35,20.5791667 C20.3652778,20.5638889 18.3638889,20.9763889 16.7597222,21.4958333 Z M12.925,24.1236111 C11.3819444,26.5986111 9.86944444,28.1569444 8.98333333,28.1569444 C8.84583333,28.1569444 8.69305556,28.1111111 8.58611111,28.0194444 C8.41805556,27.8819444 8.34166667,27.6680556 8.3875,27.4541667 C8.55555556,26.5680556 10.3125,25.2847222 12.925,24.1236111 Z",
    id: "Icon",
    fill: "#FFFFFF"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdobeReader);
export default __webpack_public_path__ + "static/media/icon-adobe-reader.ad93caa8.svg";
export { ForwardRef as ReactComponent };